import React, { useEffect, useState } from 'react'
import * as FietsenMintjensAPI from '../../api/FietsenMintjensAPI'
import { Input, Button, Select, Checkbox } from 'antd'

const { Option } = Select

const LeasingRequest = ({ productId, productCategory }) => {
  const [product, setProduct] = useState(null)
  const [submitted, setSubmitted] = useState(false)
  const [formData, setFormData] = useState({
    leasingPartner: '',
    employerName: '',
    fullName: '',
    street: '',
    houseNumber: '',
    postalCode: '',
    city: '',
    phone: '',
    email: '',
    gdpr: false,
  })
  const [formError, setFormError] = useState('')

  useEffect(() => {
    let mainCategory = productCategory.toLowerCase() === 'accessoires' ? 'accessoires' : 'fietsen'
    FietsenMintjensAPI.getProductsById(productCategory, productId, mainCategory)
      .then(res => setProduct(res.data))
      .catch(err => console.error(err))
  }, [productId, productCategory])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }))
  }

  const handleSelectChange = (value) => {
    setFormData(prev => ({
      ...prev,
      leasingPartner: value
    }))
  }

  const validateForm = () => {
    if (!formData.leasingPartner) return 'Selecteer een leasingmaatschappij.'
    if (!formData.employerName) return 'Vul de naam van de werkgever in.'
    if (!formData.fullName) return 'Vul je voor- en achternaam in.'
    if (!formData.street) return 'Vul je straat in.'
    if (!formData.houseNumber) return 'Vul je huisnummer in.'
    if (!formData.postalCode) return 'Vul je postnummer in.'
    if (!formData.city) return 'Vul je gemeente in.'
    if (!formData.phone) return 'Vul je telefoonnummer in.'
    if (!formData.email) return 'Vul je e-mailadres in.'
    if (!formData.gdpr) return 'Je moet toestemming geven om gemaild te worden.'
    return ''
  }

  const onFinish = (e) => {
    e.preventDefault()
    const error = validateForm()
    if (error) {
      setFormError(error)
      return
    }
    setFormError('')

    console.log('Submitting formData:', formData)

    // Create a hidden form
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = 'https://hooks.zapier.com/hooks/catch/5264725/2ppzz4w/'
    form.style.display = 'none'

    // Add all form data as hidden inputs (force string)
    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = key
      input.value = value == null ? '' : String(value)
      form.appendChild(input)
    })

    // Add product info
    const productNameInput = document.createElement('input')
    productNameInput.type = 'hidden'
    productNameInput.name = 'productName'
    productNameInput.value = product.name
    form.appendChild(productNameInput)

    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)

    setTimeout(() => setSubmitted(true), 500)
  }

  const responsiveStyles = `
  @media (max-width: 900px) {
    .leasing-flex {
      flex-direction: column !important;
      gap: 24px !important;
    }
    .leasing-left, .leasing-right {
      max-width: 100% !important;
      min-width: 0 !important;
      width: 100% !important;
    }
    .leasing-left {
      order: 1 !important;
    }
    .leasing-right {
      order: 2 !important;
    }
  }
  @media (max-width: 600px) {
    .leasing-container {
      padding: 8px !important;
    }
    .leasing-title {
      font-size: 24px !important;
    }
    .leasing-flex {
      gap: 12px !important;
    }
    .ant-form-item label {
      font-size: 11px !important;
    }
  }
  `;

  if (!product) return <div>Loading...</div>

  return (
    <>
      <style>{responsiveStyles}</style>
      <div style={{
        maxWidth: 1100,
        margin: '40px auto',
        padding: 24,
        background: '#fff',
        borderRadius: 8,
        boxShadow: '0 2px 8px #f0f1f2'
      }}>
        {/* Centered Title and Intro */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{ color: '#d32f2f', fontWeight: 700, marginBottom: 16, fontSize: 36 }}>
            Fietsleasing: Slim, Voordelig en Duurzaam
          </h1>
          <p style={{ marginBottom: 8, fontSize: 16, maxWidth: 600, margin: '0 auto' }}>
            Wil je zonder zorgen genieten van een kwalitatieve fiets, zowel voor woon-werkverkeer als voor ontspanning? Met fietsleasing via je werkgever geniet je van de perfecte combinatie van gemak, flexibiliteit en een financieel voordeel.
          </p>
          <br />
          <p style={{ marginBottom: 0, fontSize: 16, maxWidth: 600, margin: '0 auto'  }}>
            Vul onderstaande gegevens in en wij zorgen voor een offerte die 100% klaar is!<br />
            Deze word je via mail verzonden.
          </p>
        </div>
        {/* Two-column layout */}
        <div className="leasing-flex" style={{
          display: 'flex',
          gap: 40,
          alignItems: 'flex-start',
          justifyContent: 'center'
        }}>
          {/* Left: Product Info */}
          <div className="leasing-left" style={{
            flex: '1 1 350px',
            minWidth: 320,
            maxWidth: 400,
            background: '#f9f9f9',
            borderRadius: 8,
            padding: 24,
            boxSizing: 'border-box',
            textAlign: 'center'
          }}>
            {product.image && product.image !== -1 && (
              <img
                src={product.image}
                alt={product.name}
                style={{
                  width: '100%',
                  maxWidth: 260,
                  height: 'auto',
                  borderRadius: 8,
                  marginBottom: 20,
                  objectFit: 'contain',
                  background: '#fff'
                }}
              />
            )}
            <div style={{ fontWeight: 700, fontSize: 20, marginBottom: 8 }}>{product.name}</div>
            <div style={{ color: '#888', fontSize: 15 }}>{product.description}</div>
          </div>
          {/* Right: Form */}
          <div className="leasing-right" style={{
            flex: '1 1 400px',
            minWidth: 320,
            maxWidth: 500,
          }}>
            {!submitted ? (
              <>
                <iframe name="hidden_iframe" style={{display: 'none'}} title="hidden_iframe"></iframe>
                <form
                  action="https://hooks.zapier.com/hooks/catch/5264725/2ppzz4w/"
                  method="POST"
                  target="hidden_iframe"
                  onSubmit={(e) => {
                    const error = validateForm();
                    if (error) {
                      e.preventDefault();
                      setFormError(error);
                      return;
                    }
                    setFormError('');
                    setTimeout(() => setSubmitted(true), 500);
                  }}
                >
                  {/* Hidden field for product name */}
                  <input type="hidden" name="productName" value={product.name} />

                  {/* --- Gegevens Werkgever --- */}
                  <div style={{ margin: '0 0 16px' }}>
                    <div style={{
                      fontSize: 20,
                      fontWeight: 700,
                      color: '#222',
                      marginBottom: 8,
                      borderBottom: '2px solid #eee',
                      paddingBottom: 4
                    }}>
                      Gegevens werkgever
                    </div>
                  </div>
                  <div className="ant-form-item" style={{ marginBottom: 16 }}>
                    <label style={{ textTransform: 'uppercase', fontSize: 12, fontWeight: 600, color: '#d32f2f' }}>Mijn werkgever heeft als leasingpartner:</label>
                    <select
                      name="leasingPartner"
                      value={formData.leasingPartner}
                      onChange={handleChange}
                      required
                      style={{
                        width: '100%',
                        padding: '8px',
                        borderRadius: 4,
                        border: '1px solid #d9d9d9',
                        fontSize: 16,
                        marginTop: 4,
                        marginBottom: 4
                      }}
                    >
                      <option value="">Selecteer leasingmaatschappij</option>
                      <option value="B2Bike">B2Bike</option>
                       <option value="Cycle Valley">Cycle Valley</option>
                      <option value="Cyclis Bike Lease">Cyclis Bike Lease</option>
                      <option value="Cyclobility">Cyclobility</option>
                      <option value="Joule">Joule</option>
                      <option value="Lease a Bike">Lease a Bike</option>
                      <option value="O2O Bicycle Lease">O2O Bicycle Lease</option>
                      <option value="B2 Bike">B2 Bike</option>
                      <option value="Andere">Andere…</option>
                      <option value="Weet ik niet">Weet ik niet…</option>
                    </select>
                  </div>
                  <div className="ant-form-item" style={{ marginBottom: 16 }}>
                    <label style={{ textTransform: 'uppercase', fontSize: 12, fontWeight: 600, color: '#d32f2f' }}>Naam werkgever</label>
                    <Input name="employerName" value={formData.employerName} onChange={handleChange} required />
                  </div>

                  {/* --- Gegevens Eindgebruiker --- */}
                  <div style={{ margin: '32px 0 16px' }}>
                    <div style={{
                      fontSize: 20,
                      fontWeight: 700,
                      color: '#222',
                      marginBottom: 8,
                      borderBottom: '2px solid #eee',
                      paddingBottom: 4
                    }}>
                      Gegevens eindgebruiker
                    </div>
                  </div>
                  <div className="ant-form-item">
                    <label style={{ textTransform: 'uppercase', fontSize: 12, fontWeight: 600, color: '#d32f2f' }}>Voor & achternaam</label>
                    <Input name="fullName" value={formData.fullName} onChange={handleChange} required />
                  </div>
                  <div className="ant-form-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ flex: 3, marginRight: '2%' }}>
                      <label style={{ textTransform: 'uppercase', fontSize: 12, fontWeight: 600, color: '#d32f2f' }}>Straat</label>
                      <Input name="street" value={formData.street} onChange={handleChange} required />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ textTransform: 'uppercase', fontSize: 12, fontWeight: 600, color: '#d32f2f' }}>Huisnummer</label>
                      <Input name="houseNumber" type="number" value={formData.houseNumber} onChange={handleChange} required />
                    </div>
                  </div>
                  <div className="ant-form-item">
                    <label style={{ textTransform: 'uppercase', fontSize: 12, fontWeight: 600, color: '#d32f2f' }}  >Postcode</label>
                    <Input name="postalCode" type="number" value={formData.postalCode} onChange={handleChange} required />
                  </div>
                  <div className="ant-form-item">
                    <label style={{ textTransform: 'uppercase', fontSize: 12, fontWeight: 600, color: '#d32f2f' }}>Gemeente</label>
                    <Input name="city" value={formData.city} onChange={handleChange} required />
                  </div>
                  <div className="ant-form-item">
                    <label style={{ textTransform: 'uppercase', fontSize: 12, fontWeight: 600, color: '#d32f2f' }}>Telefoonnummer</label>
                    <Input name="phone" type="tel" value={formData.phone} onChange={handleChange} required />
                  </div>
                  <div className="ant-form-item">
                    <label style={{ textTransform: 'uppercase', fontSize: 12, fontWeight: 600, color: '#d32f2f' }}>E-Mailadres</label>
                    <Input name="email" type="email" value={formData.email} onChange={handleChange} required />
                  </div>
                  <div className="ant-form-item" style={{ margin: '16px 0' }}>
                    <Checkbox
                      name="gdpr"
                      checked={formData.gdpr}
                      onChange={handleChange}
                      required
                    >
                      Ik geef toestemming dat Fietsen Mintjens mij mag mailen over deze aanvraag.
                    </Checkbox>
                  </div>
                  {formError && (
                    <div style={{ color: 'red', marginBottom: 16 }}>{formError}</div>
                  )}
                  <div className="ant-form-item">
                    <Button type="primary" htmlType="submit" block>
                      Vraag offerte aan
                    </Button>
                  </div>
                </form>
              </>
            ) : (
              <div style={{ color: 'green', fontWeight: 600, textAlign: 'center', padding: 24 }}>
                Bedankt voor je aanvraag! Je ontvangt spoedig een offerte via e-mail.
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default LeasingRequest
